/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormOption
 */
export interface FormOption {
    /**
     * 
     * @type {string}
     * @memberof FormOption
     */
    option: string;
    /**
     * 
     * @type {string}
     * @memberof FormOption
     */
    label: string;
}

/**
 * Check if a given object implements the FormOption interface.
 */
export function instanceOfFormOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "option" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function FormOptionFromJSON(json: any): FormOption {
    return FormOptionFromJSONTyped(json, false);
}

export function FormOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'option': json['option'],
        'label': json['label'],
    };
}

export function FormOptionToJSON(value?: FormOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'option': value.option,
        'label': value.label,
    };
}

